module.exports = __webpack_public_path__ + "media/images/investor-medtech-5f9e198a.png";